import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import StkRcptSync01Actions, { StkRcptSync01Types } from '../Stores/StkRcptSync01/Actions';

const getAppStore = state => state.app;

export function* stkRcptSync01FetchStkRcptSync01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(StkRcptSync01Actions.stkRcptSync01FetchStkRcptSync01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `stkRcpt/indexProcess/STK_RCPT_SYNC_01/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        StkRcptSync01Actions.stkRcptSync01FetchStkRcptSync01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkRcptSync01Actions.stkRcptSync01FetchStkRcptSync01Loading(false));
  }
}

export function* stkRcptSync01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/stkRcptDetail/update/${hdrId}`));
}

export function* stkRcptSync01SyncNow({ hdrIds }) {
  try {
    yield put(StkRcptSync01Actions.stkRcptSync01SyncLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `stkRcpt/syncProcess/STK_RCPT_SYNC_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(StkRcptSync01Actions.stkRcptSync01SyncNowSuccess());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkRcptSync01Actions.stkRcptSync01SyncLoading(false));
  }
}

export const saga = [
  takeLatest(StkRcptSync01Types.STK_RCPT_SYNC01_GO_TO_DOCUMENT, stkRcptSync01GoToDocument),
  takeLatest(
    StkRcptSync01Types.STK_RCPT_SYNC01_FETCH_STK_RCPT_SYNC01,
    stkRcptSync01FetchStkRcptSync01
  ),
  takeLatest(StkRcptSync01Types.STK_RCPT_SYNC01_SYNC_NOW, stkRcptSync01SyncNow)
];
